import plugin from "./plugin.js";

export default plugin;
